<template>
  <v-layout column fill-height justify-start class="white">
    <scroll-area>
      <template slot="header">
        <v-toolbar dense flat color="white">
            <v-toolbar-title class="caption accent--text text-uppercase font-weight-normal font-condensend">{{$t('access manager')}}</v-toolbar-title>
        </v-toolbar>
      </template>
      <template slot="body">
        <v-layout column v-if="getPlaces[panel] == 'structure'" fill-height justify-start>
          <v-list>
            <draggable v-bind="isEdit" v-model="model.children">
              <template v-for="(child, i) in model.children">
                <v-list-tile :key="child + '_ol_' + i" avatar>
                      <v-layout :style="`border-radius: 4px; background-color: ${$getColor($store.state.monitoring.status[child.$id])}`" pl-2>
                        <v-layout class="white">
                          <svg-icon
                            color="blackLine"
                            :name="$checkItem(child)"
                            width="34"
                          />
                          <v-list-tile-content>
                            <v-list-tile-title >
                              <v-layout px-2>
                                <span class="blacktext--text caption" >{{ child.name }}</span>
                              </v-layout>
                            </v-list-tile-title>
                          </v-list-tile-content>
                        </v-layout>
                      </v-layout>
                </v-list-tile>
              </template>
            </draggable>
          </v-list>
        </v-layout>

        <v-layout column v-if="getPlaces[panel] == 'access manager'" fill-height justify-start>
          <v-layout shrink>
            <v-flex xs4 shrink px-0 pb-2> 
              <v-text-field
                :value="$t('read access rules')"
                light
                outline
                flat
                readonly
                disabled
                class="backgrey"
                persistent-hint
                hide-details
                :rows="1"
                color="white"
              >
              </v-text-field>
            </v-flex>

            <v-flex xs8 shrink px-0 pb-2>      
              <v-select
                :data-testid="$options.name + '__select__' + 'rules.read'"
                v-model="rules.read"
                light
                :items="users"
                outline
                :placeholder="$t('choose users')"
                hide-details
                class="white"
                color="primary"
                background-color="backgrey"
                multiple
                clearable
              >
                <template v-slot:item="{ item, index }">
                  <span>{{ item }}</span>
                </template>
                <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0" :key="index">{{ item}}</span>
                  <span v-else :key="index">{{ ', ' + item }}</span>
                </template>
                
              </v-select>
            </v-flex>
          </v-layout>

          <v-layout shrink>
            <v-flex xs4 shrink px-0 pb-2>        
              <v-text-field
                :value="$t('write access rules')"
                light
                outline
                flat
                readonly
                disabled
                class="backgrey"
                persistent-hint
                hide-details
                :rows="1"
                color="white"
              >
              </v-text-field>
            </v-flex>

            <v-flex xs8 shrink px-0 pb-2>     
              <v-select
                :data-testid="$options.name + '__select__' + 'rules.write'"
                v-model="rules.write"
                light
                :items="users"
                outline
                :placeholder="$t('choose users')"
                hide-details
                class="white"
                color="primary"
                background-color="backgrey"
                multiple
                clearable
              >
                <template v-slot:item="{ item, index }">
                  <span>{{ item }}</span>
                </template>
                <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0" :key="index">{{ item}}</span>
                  <span v-else :key="index">{{ ', ' + item }}</span>
                </template>
              </v-select>

            </v-flex>
          </v-layout>

          <v-layout shrink>
            <v-flex xs4 shrink px-0 pb-2>           
              <v-text-field
                :value="$t('access rules for receiving sms')"
                light
                outline
                flat
                readonly
                disabled
                class="backgrey"
                persistent-hint
                hide-details
                :rows="1"
                color="white"
              >
              </v-text-field>
            </v-flex>

            <v-flex xs8 shrink px-0 pb-2>
              <v-select
                :data-testid="$options.name + '__select__' + 'rules.sms'"
                v-model="rules.sms"
                light
                :items="users"
                outline
                :placeholder="$t('choose users')"
                hide-details
                class="white"
                color="primary"
                background-color="backgrey"
                multiple
                clearable
              >
                <template v-slot:item="{ item }">
                  <v-layout justify-space-between align-center>
                    <span>{{ item }}</span>
                    <v-tooltip v-if="getRules.sms.includes(item)" dark left>
                      <v-btn icon flat slot="activator" 
                      :data-testid="$options.name + '__btn_sms_' + item"
                      @click.stop="() => getAccessDetails(item, 'sms')">
                        <v-icon small >edit</v-icon>
                      </v-btn>
                      <span>{{ $t('customize notification statuses') }}</span>
                    </v-tooltip>
                  </v-layout>                
                </template>   
                <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0" :key="index">{{ item}}</span>
                  <span v-else :key="index">{{ ', ' + item }}</span>
                </template>      
              </v-select>
            </v-flex>
          </v-layout>

          <v-layout shrink>
            <v-flex xs4 shrink px-0 pb-2>          
              <v-text-field
                :value="$t('access rules for receiving email')"
                light
                outline
                flat
                readonly
                disabled
                class="backgrey"
                persistent-hint
                hide-details
                :rows="1"
                color="white"
              >
              </v-text-field>

            </v-flex>

            <v-flex xs8 shrink px-0 pb-2>    
              <v-select
                :data-testid="$options.name + '__select__' + 'rules.email'"
                v-model="rules.email"
                light
                :items="users"
                outline
                :placeholder="$t('choose users')"
                hide-details
                class="white"
                color="primary"
                background-color="backgrey"
                multiple
                clearable
              >
                <template v-slot:item="{ item }">
                  <v-layout justify-space-between align-center>
                    <span>{{ item }}</span>
                    <v-tooltip v-if="getRules.email.includes(item)" dark left>
                      <v-btn icon flat slot="activator" 
                      :data-testid="$options.name + '__btn_email_' + item"
                      @click.stop="() => getAccessDetails(item, 'email')">
                        <v-icon small >edit</v-icon>
                      </v-btn>
                      <span>{{ $t('customize notification statuses') }}</span>
                    </v-tooltip>
                  </v-layout>                
                </template>  
                <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0" :key="index">{{ item}}</span>
                  <span v-else :key="index">{{ ', ' + item }}</span>
                </template>             
              </v-select>
            </v-flex>
          </v-layout>

          <v-layout shrink>
            <v-flex xs4 shrink px-0 pb-2>  
              <v-text-field
                :value="$t('access rules for receiving push-notifications')"
                light
                outline
                flat
                readonly
                disabled
                class="backgrey"
                persistent-hint
                hide-details
                :rows="1"
                color="white"
              >

              </v-text-field>
            </v-flex>

            <v-flex xs8 shrink px-0 pb-2>   
              <v-select
                :data-testid="$options.name + '__select__' + 'rules.push'"
                v-model="rules.push"
                light
                :items="users"
                outline
                :placeholder="$t('choose users')"
                hide-details
                class="white"
                color="primary"
                background-color="backgrey"
                multiple
                clearable
              >
                <template v-slot:item="{ item }">
                  <v-layout justify-space-between align-center>
                    <span>{{ item }}</span>
                    <v-tooltip v-if="getRules.push.includes(item)" dark left>
                      <v-btn icon flat slot="activator" 
                      :data-testid="$options.name + '__btn_push_' + item"
                      @click.stop="() => getAccessDetails(item, 'push')">
                        <v-icon small >edit</v-icon>
                      </v-btn>
                      <span>{{ $t('customize notification statuses') }}</span>
                    </v-tooltip>
                  </v-layout>                
                </template>   
                <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0" :key="index">{{ item}}</span>
                  <span v-else :key="index">{{ ', ' + item }}</span>
                </template>            
              </v-select>
            </v-flex>
          </v-layout>

          <v-flex shrink px-0>
            <v-layout fill-height justify-end >
              <v-btn dark outline :disabled="!check" small :data-testid="$options.name + '__btn__' + 'cancel'" @click="setup" color="blacktext">{{$t('cancel')}}</v-btn>
            </v-layout>
          </v-flex>

        </v-layout>
      </template>
    </scroll-area>

    <v-dialog persistent v-model="access_details_modal.show" max-width="50%" v-if="access_details_modal.show">
      <access-details-card
        :user="access_details_modal.user"
        :rule="access_details_modal.rule"
        :acess_details="getUserAccessDetails"      
        @changeAccessDetails="(payload) => saveAccessDetails(payload)"
        @close="() => {access_details_modal.show = !access_details_modal.show; access_details_modal.user = null}"
      />
    </v-dialog>

  </v-layout>
</template>

<script lang="ts">
import Vue from 'vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import accessDetailsCard from '@/nms/pages/location/access-details-card.vue'
import svgIcon from '@/nms/components/media/svg/static/svg-icon.vue'
import draggable from 'vuedraggable'

// Типы
interface RuleItem {
  read: string[]
  write: string[]
  sms: string[]
  email: string[]
  push: string[]
  [key: string]: string[]
}

interface AccessDetailsItem {
  alarm: boolean
  damage: boolean
  warning: boolean
  unknown: boolean
  ok: boolean
  [key: string]: boolean
}

interface AccessDetailsRule {
  [user: string]: AccessDetailsItem
}

interface AccessDetailsData {
  [rule: string]: AccessDetailsRule
}

interface AccessDetailsModal {
  show: boolean
  user: string | null
  rule: string | null
}

interface ModelData {
  children: any[]
}

interface LocationData {
  $id?: string
  access?: {
    [rule: string]: string[]
  }
  access_details?: {
    [rule: string]: {
      [user: string]: {
        [status: string]: boolean
      }
    }
  }
  [key: string]: any
}

interface DefaultRulesResponse {
  defaultAccessObject?: RuleItem
  defaultAccessDetailsObject?: AccessDetailsData
}

interface CmdbQueryResponse {
  children?: any[]
  [key: string]: any
}

interface SaveAccessDetailsPayload {
  user: string | null
  rule: string | null
  access_details: AccessDetailsItem
}

interface ComponentData {
  users: string[]
  places: string[]
  panel: number
  edit: boolean
  items: any[]
  model: ModelData
  rules: RuleItem
  access_details: AccessDetailsData
  access_details_template: AccessDetailsItem
  access_details_modal: AccessDetailsModal
  checkRules: RuleItem
  check: boolean
}

export default Vue.extend({
  name: 'LOCATION_SETTINGS',

  components: {
    scrollArea,
    accessDetailsCard,
    svgIcon,
    draggable
  },

  props: {
    data: {
      type: Object as () => LocationData,
      default: () => ({})
    },
  },

  data(): ComponentData {
    return {
      users: [],
      places: ['access manager', 'structure'],
      panel: 0,
      edit: true,
      items: [],
      model: {
        children: []
      },
      rules: {
        read: [],
        write: [],
        sms: [],
        email: [],
        push: [],
      },
      access_details: {},
      access_details_template: {
        alarm: true,
        damage: true,
        warning: true,
        unknown: true,
        ok: true
      },
      access_details_modal: {
        show: false,
        user: null,
        rule: null
      },
      checkRules: {
        read: [],
        write: [],
        sms: [],
        email: [],
        push: [],
      },
      check: false,
    }
  },

  computed: {
    getUserAccessDetails(): AccessDetailsItem | object {
      const user = this.access_details_modal.user
      const rule = this.access_details_modal.rule
      
      if (user && rule) {
        return this.access_details[rule]?.[user] || this.access_details_template
      }
      return {}
    },

    getPlaces(): string[] {
      return this.places
    },

    getRules(): RuleItem {
      return this.rules
    },

    getData(): LocationData {
      return this.data
    },

    isEdit(): { disabled: boolean } {
      return {
        disabled: !this.edit
      }
    }
  },

  watch: {
    rules: {
      handler(newVal: RuleItem): void {
        this.check = false
        Object.keys(this.rules).forEach(key => {
          const rulesKey = key as keyof RuleItem
          if (this.checkRules[rulesKey] && this.checkRules[rulesKey].length !== this.rules[rulesKey].length) {
            this.check = true
          }
        })
        this.$emit('access', JSON.stringify(this.rules))
      },
      deep: true
    },

    data: {
      handler(): void {
        this.setup()
      },
      deep: true
    },

    'model.children': {
      handler(newVal: any[]): void {
        if (newVal?.length) {
          console.log('WATCH', this.$options.name, 'MODEL.CHILDREN', newVal)
          this.$emit('changeChildren', newVal)
        }
      },
      deep: true
    },
  },

  created(): void {
    this.setup()
  },

  methods: {
    async setup(): Promise<void> {
      this.reset()
      if (this.getData?.$id) {
        await this.loadDevice()
      }
      await this.loadDefaultRules()
      this.loadUsers()
    },

    async loadDevice(): Promise<void> {
      const devices: any[] = []
      console.log(this.$options.name, 'loadDevice this.getData.$id', this.getData.$id)
      
      const query = {
        id: [this.getData.$id],
        notNull: true,
        data: {
          namePath: true,
          children: {
            data: { namePath: true },
            filter: { or: [{ cls: 'location' }, { cls: 'cabinet' }, { cls: 'device' }] }
          },
        }
      }
      
      const co = await this.$bridge.cmdbQuery(query) as CmdbQueryResponse[]
      if (co?.[0]?.children?.length) {
        co[0].children.forEach((child: any) => {
          if (child.cls !== 'device' || child.tree_view) {
            devices.push(child)
          }
        })
        this.$set(this.model, 'children', devices)
      }
    },

    async loadDefaultRules(): Promise<void> {
      try {
        const r = await this.$bridge.customQuery('cmdb', 'access/defaultSettings', {}, 'get') as DefaultRulesResponse
        if (r?.defaultAccessObject) {
          this.rules = r.defaultAccessObject
        }
        if (r?.defaultAccessDetailsObject) {
          this.access_details = r.defaultAccessDetailsObject
        }
      } catch (err) {
        console.error('loadDefaultRules error', err)
      }
    },

    async loadUsers(): Promise<void> {
      this.setLoader('loadUsers', true)
      this.users = []
      
      const query = {
        id: ['/catalogs/user'],
        notNull: true,
        data: {
          namePath: true,
          links: { flatten: false }
        }
      }
      
      const book = await this.$bridge.cmdbQuery(query) as any[]
      const users: string[] = []
      
      book[0]?.links?.forEach((user: any) => {
        users.push(user.name)
      })
      
      this.users = users
      this.setLoader('loadUsers', false)
      this.prepareData()
    },

    prepareData(): void {
      console.log(this.$options.name, 'prepareData', 'this.data', this.data)
      
      if (this.data.access) {
        Object.keys(this.data.access).forEach(key => {
          const ruleKey = key as keyof RuleItem
          if (this.data.access?.[ruleKey]?.length) {
            this.data.access[ruleKey]?.forEach((user: string) => {
              if (user.startsWith('*')) {
                this.rules[ruleKey].push(user.slice(1))
              } else {
                this.rules[ruleKey].push(user)
              }
            })
          }
        })
      }

      if (this.data.access_details) {
        const notificationTypes = Object.keys(this.data.access_details)
        console.log(this.$options.name, 'prepareData', 'notificationTypes', notificationTypes)
        
        notificationTypes.forEach(type$ => {
          console.log(this.$options.name, 'prepareData', 'type$', type$)
          this.$set(this.access_details, type$, {})
          
          if (Object.keys(this.data.access_details?.[type$] || {}).length) {
            const users$ = Object.keys(this.data.access_details[type$])
            users$.forEach(user => {
              this.$set(this.access_details[type$], user, this.$merge({}, this.access_details_template))
              const statuses$ = Object.keys(this.access_details_template)
              statuses$.forEach(status => {
                if (this.data.access_details?.[type$]?.[user]?.hasOwnProperty(status)) {
                  this.$set(this.access_details[type$][user], status, this.data.access_details[type$][user][status])
                } else {
                  this.$set(this.access_details[type$][user], status, false)
                }
              })
            })
          }
        })
        console.log(this.$options.name, 'prepareData', 'this.access_details', this.access_details)
      }
      
      const checkRules$ = this.$merge({}, this.rules) as RuleItem
      this.checkRules = checkRules$
    },

    getAccessDetails(user: string, rule: string): void {
      this.$set(this.access_details_modal, 'user', user)
      this.$set(this.access_details_modal, 'rule', rule)
      this.$set(this.access_details_modal, 'show', true)
    },

    saveAccessDetails(payload: SaveAccessDetailsPayload): void {
      if (payload.user && payload.rule && payload.access_details) {
        this.$set(this.access_details[payload.rule], payload.user, payload.access_details)
      }
      this.$emit('accessDetails', JSON.stringify(this.access_details))
      this.$set(this.access_details_modal, 'show', false)
    },

    reset(): void {
      this.users = []
      this.places = ['access manager', 'structure']
      this.panel = 0
      this.edit = true
      this.items = []
      this.model = { children: [] }
      this.rules = {
        read: [],
        write: [],
        sms: [],
        email: [],
        push: [],
      }
      this.access_details = {}
      this.access_details_template = {
        alarm: true,
        damage: true,
        warning: true,
        unknown: true,
        ok: true
      }
      this.access_details_modal = {
        show: false,
        user: null,
        rule: null
      }
      this.checkRules = {
        read: [],
        write: [],
        sms: [],
        email: [],
        push: [],
      }
      this.check = false
    },

    setLoader(name: string, status: boolean): void {
      this.$store.dispatch('setLoader', {
        key: name,
        value: status
      })
    },
  },
})
</script>

<style scoped>
</style>
